import { render, staticRenderFns } from "./MapGijon.vue?vue&type=template&id=2e4db2d4&"
import script from "./MapGijon.vue?vue&type=script&lang=js&"
export * from "./MapGijon.vue?vue&type=script&lang=js&"
import style0 from "./MapGijon.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports